import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'childGroupFidelity',
    label: 'Child Group Fidelity',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
